import {AppState} from '@app/context/context';

export interface UpdateOrdersEvent {
    orders: Partial<AppState['orders']>;
}

export function emitOrdersUpdate(
    setState: React.Dispatch<React.SetStateAction<AppState>>,
    event: UpdateOrdersEvent
) {
    setState((prevState: AppState) => {
        const updatedOrders = {
            ...prevState.orders,
            ...event.orders
        };

        return {
            ...prevState,
            orders: updatedOrders
        };
    });
}
